import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 5,
  pageOptions: [3, 5, 10],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'code', label: 'Code',},
    { key: 'name', label: 'Name', sortable: true },
    { key: 'privilege_category_code', label: 'Category Code', sortable: true },
    { key: 'privilege_category_name', label: 'Category Name'},
    { key: 'created_at', label: 'Created At'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  items: [],
  role: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }, params) {
    let param = {status: 'master/privilege-categ', params}
    useIPA.get(param).then(response => {
      const privilege = {
        rows : response.data.data
      }
      const { pagination } = response.data
      commit('setData', {...privilege})
      commit('setPagination', pagination)
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/privilege-categ/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        id: formData.id,
        privilege_category_id: parseInt(formData.select_1),
        code: formData.text_3,
        name: formData.text_2
			}
      const param = { rawData: rawData, url: 'internal/master/privilege-categ', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'privilege-in' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/privilege-categ/', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, privilege) {
    state.items = privilege.rows
    state.totalRows = privilege.rows.length
    for (let i = 0; i < privilege.rows.length; i++) {
      const option = []
      for (const key in privilege.rows[i]) {
        option['module'] = privilege.rows[i]['name'] 
        option['access'] = privilege.rows[i]['id'] 
      } 
      state.role.push(Object.assign({}, option))
    }
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
